<template>
  <div id="app">
    <NavBar />

    <transition name="fade">
      <router-view></router-view>
    </transition>

    <Footer />

    <button @click="goToTop()" class="goToTopButton" ref="goToTopButton" v-if="goToTopVisible">
      <font-awesome-icon
        :icon="['fas', 'chevron-up']"
        size="lg"
        :style="{ color: 'black' }"
        fixed-width
      />
    </button>
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "app",
  components: {
    NavBar,
    Footer
  },
  data() {
    return {
      goToTopVisible: false
    };
  },
  methods: {
    handleScroll() {
      let scrollTop = window.pageYOffset || document.body.scrollTop;

      if (scrollTop > 150) {
        this.goToTopVisible = true;
        if (this.$refs.goToTopButton) {
          this.$refs.goToTopButton.classList.add("show");
        }
      } else {
        this.goToTopVisible = false;
      }
    },
    goToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.2s;
}

.fade-enter-active {
  transition-delay: 0.2s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}

html,
body {
  width: 100%;
  height: 100%;
}

.goToTopButton {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 99;
  border: none;
  outline: none;
  background-color: white;
  color: white;
  cursor: pointer;
  border-radius: 50%;
  border: solid 2px #2c3e50;
  width: 3rem;
  height: 3rem;

  display: flex;
  justify-content: center;
  margin: auto;

  transition-timing-function: ease-in;
  transition: 0.2s;
  transform: translateX(-30%);
}

.goToTopButton > svg {
  display: block;
  margin: auto;
}

.goToTopButton.show {
  transition-timing-function: ease-out;
  transition: 0.25s;
  transform: translateX(0);
}

.separator {
  width: 100%;
  height: 1rem;
}
</style>

